const LangForgotPassword = {
	"forgotPassword._title": ["FORGOT PASSWORD", "QUÊN MẬT KHẨU"],
	"forgotPassword.form.button._resetMyPassword": [
		"Reset My Password",
		"Thay đổi mật khẩu",
	],
	"forgotPassword._description": [
		`Please enter the email address you used to sign up for your Starbucks account. We will send you an email with information on how to reset your password.`,
		`Vui lòng nhập địa chỉ email bạn đã đăng ký tại đây. Chúng tôi sẽ gửi thông tin hướng dẫn bạn cách chọn lại mật khẩu.`,
	],
}

export default LangForgotPassword
